import { Option } from 'components/elements/FloatingToolbar/types'

import Link from 'components/elements/Link'
import Icon from 'components/elements/Icon'
import ManaFrontIcon from 'components/misc/customIcons/ManaFont'
import CustomIcon from 'components/elements/CustomIcon'

import styles from './listItem.module.scss'

const FloatingToolbarListOption = ({
  icon,
  manaFontIcon,
  customIcon,
  iconElement,
  label,
  disabled,
  onClick,
  keybind,
  style,
  className = '',
  to,
  target,
  hidden,
}: Option) => {
  if (hidden) return null

  const base = (
    <button className={`${styles.item} ${className}`} onClick={onClick} disabled={disabled} style={style}>
      <span className={styles.primary}>
        {icon && <Icon name={icon} />}
        {manaFontIcon && <ManaFrontIcon icon={manaFontIcon} />}
        {customIcon && <CustomIcon name={customIcon} />}
        {iconElement}
        <span>{label}</span>
      </span>

      {keybind && <span className={styles.keybind}>{keybind}</span>}
    </button>
  )

  if (to)
    return (
      <Link href={to} target={target}>
        {base}
      </Link>
    )

  return base
}

export default FloatingToolbarListOption
